import React from "react";
import image from "../assets/promotion_bg.webp";

const PromotionalBanner = ({ page }) => {
  return (
    <div
      className="text-white text-center py-3 px-3"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <p className="text-sm">
        Get 40% off your order for limited time only.{" "}
        {page === "homepage" && (
          <a href="#offer" className="underline hover:text-purple-100">
            Read more
          </a>
        )}
      </p>
    </div>
  );
};

export default PromotionalBanner;
